export const getStoredVisitorCode = () => {
    try {
        if (typeof localStorage === "undefined")
            return null;
        const raw = localStorage.getItem("kameleoonConsentData");
        if (!raw)
            return null;
        const parsed = JSON.parse(raw);
        const keys = Object.keys(parsed);
        // new user, stay silent
        if (keys.length === 0)
            return null;
        // should only be one key
        if (keys.length !== 1)
            throw new Error(`Expected only one key, but found ${keys.length}`);
        return keys[0];
    }
    catch (err) {
        console.warn("[Kameleoon] Failed to get active visitor code:", err);
        return null;
    }
};
